export const newsletterState = state => state.v1.newsletter;